import { TOptions } from '../../types/options';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EPeriodsActionTypes {
  Loading = 'options/loading',
  Succeed = 'options/succeed',
  Failed = 'options/failed',
}

export type TGetPeriodsLoading = ITypedReduxAction<EPeriodsActionTypes.Loading>;
export type TGetPeriodsSucceed = ITypedReduxAction<EPeriodsActionTypes.Succeed, TOptions[]>;
export type TGetPeriodsFailed = ITypedReduxAction<EPeriodsActionTypes.Failed>;

export type TGetOptions = TGetPeriodsLoading | TGetPeriodsSucceed | TGetPeriodsFailed;
